"use client"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs" 
import { EntryReportList } from "./entry-report-list"

export function EntryReportContainer() {
  return (
    <>
      <Breadcrumbs mainTitle="Entry Reports" parent="Reports" />
      <Container fluid>
        <Row>
          <Col md="12 gap-4">
            <EntryReportList />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default EntryReportContainer
